import { isUnknownErrorResponse } from '@ts-rest/core';
export { exhaustiveGuard, isUnknownErrorResponse } from '@ts-rest/core';

const isFetchError = (error) => {
    return error instanceof Error;
};
const isNotKnownResponseError = (error, contractEndpoint) => {
    return isFetchError(error) || isUnknownErrorResponse(error, contractEndpoint);
};

export { isFetchError, isNotKnownResponseError };
